export const ID = '5eaca16d-1df3-4548-9334-951a7bdb7a4e';

export const NAME = 'StorageMart Checkout';
